import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ShieldNew from 'yoda-core-components/lib/assets/svg/ShieldNew.svg';
import RadioButton from 'yoda-core-components/lib/components/RadioButton/radio';
import List from 'yoda-core-components/lib/components/List/List';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import S7Image from 'yoda-core-components/lib/components/S7Image/S7Image';
import Messages, {
    messagesLevels,
    messagesActions as MessagesActions,
} from 'yoda-site-components/lib/components/Messages';
import * as styles from './BundleProtectionPlan.css';
import selectBundleProtectionPlanAction from '../../../actions/BundleProtectionPlanAction';
import { openModalAnalytics } from '../../../actions/AnalyticsAction';
import selectedProtectionPlan from '../../../selectors/Bundle/BundleProtectionPlanSelector';

const cx = classNames.bind(styles);

export class ProtectionPlan extends Component {
    static defaultProps = {
        productDetails: {},
        dataAutomationId: null,
        actions: {},
        productImages: [],
        selectedProductLot: [],
        selectedProtectionPlan: 'no',
        messages: [],
        enableWarrantySection: false,
    };

    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        // selectedProductLot: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        dataAutomationId: PropTypes.string,
        selectedProtectionPlan: PropTypes.string,
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        messages: PropTypes.oneOfType([PropTypes.array]),
        enableWarrantySection: PropTypes.bool,
    };

    constructor() {
        super();
        this.state = {
            isModalOpen: false,
            protectionDetails: {},
            isChildProtectionPlanSelected: {},
        };
        this.protectionPlanOnChange = this.protectionPlanOnChange.bind(this);
    }

    openModal(warranty) {
        this.setState({ isModalOpen: true, protectionDetails: warranty });
        this.props.actions.openModalAnalytics(warranty.name);
    }

    closeModal = () => {
        this.setState({ isModalOpen: false, protectionDetails: {} });
    };

    protectionPlanOnChange(evt) {
        const { productDetails } = this.props;
        const productProtectionPlan = {};
        productProtectionPlan[productDetails.id] = evt.target.value;
        this.props.actions.removeAllMessages({
            section: `PROTECTION_PLAN_MESSAGES_SECTION_${productDetails.id}`,
            sourceMiniPDP: false,
        });
        this.props.actions.selectBundleProtectionPlanAction(productProtectionPlan);
    }

    referenceNumber(number) {
        let warrentyNumber = '';
        /* istanbul ignore next */
        if (number) {
            warrentyNumber = <p> warranty ref #: {this.state.protectionDetails.referenceNumber}</p>;
        }
        return warrentyNumber;
    }

    protectionPlanMessage(includedProtectionPlan, additionalProtectionPlan) {
        let message = null;
        /* istanbul ignore next */
        if (includedProtectionPlan.length && additionalProtectionPlan.length) {
            message = <h4> Additional Protection Plans </h4>;
        } else if (additionalProtectionPlan.length) {
            message = <h4> Protection Plans </h4>;
        }
        return message;
    }

    protectionPlanRenderer = (warranties) => {
        const { dataAutomationId, productDetails, enableWarrantySection } = this.props;
        const toFilter = new Set([true]);
        const includedProtectionPlan = warranties.filter((obj) => toFilter.has(obj.selected));
        const additionalProtectionPlan = warranties.filter((obj) => toFilter.has(!obj.selected));
        /* FREE included protectionPlan content Renderer */
        /* istanbul ignore next */
        const includedProtectionPlanRenderer = includedProtectionPlan.length &&
            includedProtectionPlan[0].name.trim().toUpperCase() !== 'NO WRITTEN WARRANTY' && (
                <div className={cx('includedProtectionPlanContainer')}>
                    <div className={cx('protectionPlan')}>
                        <span className={cx('protectionIcon')}>
                            <Icon
                                iconType="svg"
                                pathClassName={cx('iconPath')}
                                className={cx('svg-icon')}
                                width="24px"
                                height="24px"
                                viewBox="0 0 20 20"
                            >
                                <ShieldNew />
                            </Icon>
                        </span>
                        <Button
                            buttonType="Link"
                            className="yearLabel"
                            onClick={() => this.openModal(includedProtectionPlan[0])}
                            automationId={`${dataAutomationId}-1-link`}
                            aria-label={`link-${dataAutomationId}-1`}
                        >
                            Limited Warranty Included
                        </Button>
                    </div>
                </div>
            );

        /* List renderer for additional protectionPlan content */
        const renderProtectionPlanContent = (dataItem, index) => {
            const { isChildProtectionPlanSelected } = this.state;
            const {
                productDetails: { id },
            } = this.props;
            /* istanbul ignore next */
            // to set default protection plan option as No Thank You.
            if (dataItem.name !== 'No Thank You' && !isChildProtectionPlanSelected[id]) {
                const productProtectionPlan = {};
                productProtectionPlan[id] = 'no';
                this.props.actions.selectBundleProtectionPlanAction(productProtectionPlan);
                const modifiedisChildProtectionPlanSelected = {
                    ...isChildProtectionPlanSelected,
                };
                modifiedisChildProtectionPlanSelected[id] = true;
                this.setState({
                    isChildProtectionPlanSelected: modifiedisChildProtectionPlanSelected,
                });
            }
            /* istanbul ignore next */
            const protectionPlanBlock = (
                <div className={cx('additionalProtectionPlan')}>
                    <RadioButton
                        id={`${productDetails.id}_radio${index + 2}`}
                        name={`${productDetails.id}warantyGroup`}
                        value={dataItem.itemId ? dataItem.itemId : 'no'}
                        label={dataItem.name ? dataItem.name : 'no'}
                        checked={
                            dataItem.name === 'No Thank You'
                                ? this.props.selectedProtectionPlan === 'no' ||
                                  !this.state.isChildProtectionPlanSelected
                                : this.props.selectedProtectionPlan === dataItem.itemId
                        }
                        onChange={this.protectionPlanOnChange}
                        automationId="protection-plan"
                    />
                    {dataItem.name !== 'No Thank You' && (
                        <>
                            <span className={cx('price')}> ${dataItem.price} </span>
                            <div className={cx('detailPrice')}>
                                <span className={cx('seeDetails')}>
                                    <Button
                                        buttonType="Link"
                                        className={cx(
                                            'protectionPlanInfoLink',
                                            'seeProtectionPlan'
                                        )}
                                        automationId={`${dataAutomationId}-${index + 2}-link`}
                                        aria-label={`link-${dataAutomationId}-${index + 2}`}
                                        onClick={() => this.openModal(dataItem)}
                                    >
                                        See Details
                                    </Button>
                                </span>
                            </div>
                        </>
                    )}
                </div>
            );

            return protectionPlanBlock;
        };
        /* Additional ProtectionPlan content Renderer */
        const additionalProtectionPlanRenderer = (
            <>
                <Messages
                    level={messagesLevels.inline}
                    id={`PROTECTION_PLAN_MESSAGES_SECTION_${productDetails.id}`}
                    messages={this.props.messages}
                />
                <div className={cx('additionalProtectionPlanContainer')}>
                    <List
                        childRenderer={renderProtectionPlanContent}
                        datasource={additionalProtectionPlan}
                        direction="Vertical"
                        itemStyleClass={cx('protectionPlanItem')}
                        listStyleClass={cx('protectionPlanList')}
                    />
                </div>
            </>
        );

        return (
            <div className={cx('ProtectionContainer')}>
                {includedProtectionPlan.length ? includedProtectionPlanRenderer : null}
                {/* eslint-disable no-nested-ternary */}
                {warranties.length > 2 &&
                    enableWarrantySection &&
                    this.protectionPlanMessage(includedProtectionPlan, additionalProtectionPlan)}

                {additionalProtectionPlan.length && warranties.length > 2 && enableWarrantySection
                    ? additionalProtectionPlanRenderer
                    : null}
            </div>
        );
    };

    render() {
        const { productDetails, dataAutomationId, productOptions } = this.props;
        let images = {};
        let productImages = {};
        let protectionPlan = {};
        /* istanbul ignore next */
        if (productOptions && Object.keys(productOptions).length) {
            productImages = productOptions.productImages;
            const protectionPlanBlock =
                productOptions.selectedProductLot.length > 0 &&
                productOptions.selectedProductLot &&
                productOptions.selectedProductLot[0].warranties &&
                productOptions.selectedProductLot[0].warranties.length;
            const protectionPlanFound =
                protectionPlanBlock &&
                productOptions.selectedProductLot.length > 0 &&
                productOptions.selectedProductLot &&
                productOptions.selectedProductLot[0].warranties.findIndex(
                    (element) => element.name === 'No Thank You'
                ) > 0;
            const additionalProtectionPlan =
                protectionPlanBlock &&
                productOptions.selectedProductLot[0].warranties.filter(
                    (warranty) => !warranty.selected
                );
            if (!protectionPlanFound && !isEmpty(additionalProtectionPlan)) {
                productOptions.selectedProductLot.length > 0 &&
                    productOptions.selectedProductLot &&
                    productOptions.selectedProductLot[0].warranties &&
                    productOptions.selectedProductLot[0].warranties.push({
                        description: '',
                        itemId: productOptions.selectedProductLot[0].warranties.itemId,
                        name: 'No Thank You',
                        price: 0,
                    });
            }
            protectionPlan = protectionPlanBlock
                ? productOptions.selectedProductLot.length > 0 &&
                  productOptions.selectedProductLot &&
                  productOptions.selectedProductLot[0].warranties
                : [];
        }
        /* istanbul ignore next */
        if (productImages && productImages.length) {
            images = productImages[0];
            /* istanbul ignore next */
        } else if (productDetails.images) {
            images = productDetails.images.find((image) => image.type === 'PRIMARY');
        }
        return (
            <div>
                {/* istanbul ignore else */}
                {protectionPlan.length ? this.protectionPlanRenderer(protectionPlan) : null}

                <ModalBox
                    showModal={this.state.isModalOpen}
                    onClose={this.closeModal}
                    defaultHeader
                    automationId="protection-modal"
                    modalBlockTheme={cx('customModalBlock')}
                >
                    <div className={cx('protectionPlanModalContainer')}>
                        <h3 className={cx('modalTitle')}> {this.state.protectionDetails.name} </h3>
                        <div className={cx('protectionPlanModalContent')} />
                        <div className={cx('protectionPlanHeader')}>
                            <div className={cx('imageContainer')}>
                                {images.url ? (
                                    <S7Image
                                        automationId={`${dataAutomationId}-s7image-0`}
                                        src={images.url}
                                        alt={images.altText}
                                        recipe="$product_pdp$"
                                    />
                                ) : null}
                            </div>

                            <div className={cx('productDetails')}>
                                <p> {productDetails.name}</p>
                                {this.referenceNumber(this.state.protectionDetails.referenceNumber)}
                            </div>
                        </div>
                        <div className={cx('protectionPlanDesc')}>
                            {' '}
                            {this.state.protectionDetails.description}
                        </div>
                    </div>
                </ModalBox>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    selectedProtectionPlan: selectedProtectionPlan(state, ownProps),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        { selectBundleProtectionPlanAction, openModalAnalytics, ...MessagesActions },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectionPlan);
